<template>
  <div class="container text-center">
    <div class="py-5">
      <h1>Cargando pasarela de pago</h1>
      <h3 v-if="paymentLabel">{{ paymentLabel }}</h3>
      <b-spinner class="mt-4" variant="primary" label="Cargando..."></b-spinner>
      <p class="text-muted mt-3 mb-0">
        {{ message }}
      </p>
    </div>
  </div>
</template>

<script>
import {
  buildPublicTicketUrl,
  normalizePublicBusinessSlug,
  redirectGatewayPayment,
  isGatewayPayment,
  isImmediateGatewayPayment,
  normalizeGatewayPaymentName,
} from "../utils/publicGateway";

export default {
  name: "Payment",
  data() {
    return {
      ticket: {
        _id: null,
        total: null,
        payment: null,
        paymentStatus: null,
        status: null,
        business: {
          name: "",
          logo: "",
        },
      },
      loading: true,
      message: "Preparando redirección...",
    };
  },
  computed: {
    paymentLabel() {
      return normalizeGatewayPaymentName(this.ticket.payment || "");
    },
  },
  mounted() {
    this.resolvePayment();
    window.scrollTo(0, 0);
  },
  methods: {
    getTicketBusinessSlug(ticket = {}) {
      if (this.$store.state.isDomain && !this.$route.params.name) {
        return "";
      }

      return normalizePublicBusinessSlug(
        this.$route.params.name ||
        ticket.webName ||
        ticket.webDomain ||
        (ticket.business && (ticket.business.webName || ticket.business.webDomain)) ||
        ticket.b ||
        ""
      );
    },
    getTicketPath(ticket = {}) {
      return buildPublicTicketUrl({
        business: this.getTicketBusinessSlug(ticket),
        ticketId: this.$route.params.id,
      });
    },
    async resolvePayment() {
      const { id } = this.$route.params;
      let ticketPath = this.getTicketPath();

      try {
        const { data } = await this.$http.get(`ticket/${id}`);
        const ticket = data && data.data ? data.data : null;

        if (!ticket) {
          this.$router.replace(ticketPath);
          return;
        }

        this.ticket = ticket;
        ticketPath = this.getTicketPath(ticket);

        const paymentName = normalizeGatewayPaymentName(ticket.payment || "");
        const isOnline = isGatewayPayment(paymentName);
        const isImmediateOnline = isImmediateGatewayPayment(paymentName);
        const isPaid = `${ticket.paymentStatus || ""}` === "ok";
        const isCanceled = `${ticket.status || ""}` === "Cancelado";

        if (!isOnline || isPaid || isCanceled || !isImmediateOnline) {
          this.$router.replace(ticketPath);
          return;
        }

        this.message = `Redirigiendo a ${paymentName}...`;

        const shouldUseBridge =
          paymentName !== "Mercado Pago" &&
          !!this.getTicketBusinessSlug(ticket);

        const redirected = await redirectGatewayPayment({
          http: this.$http,
          business: shouldUseBridge ? this.getTicketBusinessSlug(ticket) : "",
          currentUrl:
            typeof window !== "undefined"
              ? window.location.href.split("?")[0]
              : "",
          ticket: {
            _id: ticket._id,
            payment: ticket.payment,
            business: shouldUseBridge ? this.getTicketBusinessSlug(ticket) : "",
          },
        });

        if (!redirected) {
          this.$router.replace(ticketPath);
        }
      } catch (error) {
        console.error("Error resolving public payment route", error);
        this.$router.replace(ticketPath);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
